/* eslint-disable */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { devLogin } from 'apis/Session';
import useLanguageStore from 'stores/useLanguageStore';
import useSessionStore from 'stores/useSessionStore';
import { useCommonModal } from 'hooks/useCommonModal';
import useAuthStore from 'stores/useAuthStore';

const DevLoginPage = () => {
  const { openCommonModal } = useCommonModal();
  const navigate = useNavigate();
  const { changeLanguage } = useLanguageStore();
  const { setSession } = useSessionStore();

  const [userId, setUserId] = useState<string>('admin');
  const [langCd, setLangCd] = useState<string>('ko');

  const handleLogin = async () => {
    //
    const response = await devLogin(userId, langCd);
    if (response.successOrNot === 'Y' && response?.data) {
      const session = response.data;
      changeLanguage(session.langCd || 'ko');
      setSession(session);

      navigate('/system/admin/member/member-list', { replace: true });

      console.log('Login Success', session); // TODO: debug 용도 배포시 삭제
    }else {
      openCommonModal({ content: 'Login Fail' });
    }
  };

  const handleUserIdChange = (e: any) => {
    setUserId(e.target.value);
  };

  const handleLanguageChange = (e: any) => {
    setLangCd(e.target.value);
  };

  const handleKeUp = (e) => {
    if (e.key == 'Enter') {
      handleLogin();
    }
  };

  const axiosConfig = {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + useAuthStore.getState().accessToken,
    },
  };

  return (
    <>
      <hr />
      <h3>Dev Login</h3>
      User ID:
      <input type="text" value={userId} onChange={handleUserIdChange} onKeyUp={handleKeUp} />
      Langage:
      <input type="text" value={langCd} onChange={handleLanguageChange} />
      <button onClick={handleLogin}>Login</button>
      <hr />
    </>
  );
};

export default DevLoginPage;

const styles = {
  li: {
    margin: 20,
  },
};
